import { useStore } from "vuex";
import { isHydrated } from "../utils/hydration";
import type { ViewportMode } from "../utils/viewportMode";

export function useInitialViewportMode(): ViewportMode {
  const store = useStore();
  // Cached HTML can have been rendered for another viewport in its device
  // bucket. Reuse the actual SSR branch first, then reconcile on mount.
  if (!isHydrated() || typeof window === "undefined") {
    return store.state.vuefront.hydrationViewport || "desktop";
  }
  return window.innerWidth <= 767
    ? "phone"
    : window.innerWidth >= 1280
    ? "desktop"
    : "tablet";
}
